import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate, Outlet, useLocation } from "react-router-dom";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { makeStyles } from "@material-ui/core/styles";

import "../../App.css";
import Header from "../../Components/UI/Header";

const MainStageLayout = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { userInfo, abilities } = useSelector(
    (state) => state.loggedInUserInfo
  );
  const { siteConfig } = useSelector((state) => state.defs);

  const classes = useStyles();
  const [fullScreen, setFullScreen] = useState(false);
  const [userAbilities, setUserAbilities] = useState([]);

  useEffect(() => {
    if (location.pathname.split("/").includes("Content")) {
      setFullScreen(true);
    } else {
      setFullScreen(false);
    }
    if (document.documentElement.requestFullscreen) {
      document.documentElement.requestFullscreen().catch((error) => {
        console.log(`Entering fullscreen mode failed:   
        ${error.message}`);
      });
    }
  }, [location]);

  useEffect(() => {
    let arr = [];
    abilities.forEach((val) => {
      if (val.actions == "yes") {
        arr = arr.concat(val.subject);
      }
    });
    console.log("arr", arr);
    setUserAbilities(arr);
  }, [abilities]);

  const goTo = (path) => {
    navigate(path);
  };

  // Load Dynamic Image
  const loadImage = () => {
    if (location.pathname.split("/").includes("Teach")) {
      //return require('../../assets/teach.png');
    } else if (location.pathname.split("/").includes("Task")) {
      //return require('../../assets/task.png');
    } else if (location.pathname.split("/").includes("Assignment")) {
      //return require('../../assets/assignment.png');
    } else if (location.pathname.split("/").includes("Assess")) {
     // return require('../../assets/assess.png');
    } else if (
      location.pathname.split("/").includes("Insight") ||
      location.pathname.split("/").includes("Report")
    ) {
     // return require('../../assets/insight.png');
    } else if (location.pathname.split("/").includes("Library")) {
     // return require('../../assets/library.png');
    } else if (location.pathname.split("/").includes("Assign")) {
     // return require('../../assets/assign.png');
    } else if (location.pathname.split("/").includes("Rewards")) {
     // return require('../../assets/rewards.png');
    } else if (location.pathname.split("/").includes("Profile")) {
     // return require('../../assets/profile.png');
    } else if (location.pathname.split("/").includes("School")) {
     // return require('../../assets/school.png');
    } else if (location.pathname.split("/").includes("Users")) {
      //return require('../../assets/user_staff.png');
    } else if (location.pathname.split("/").includes("Dashboard")) {
      //return require('../../assets/admin_home.png');
    } else if (
      location.pathname.split("/").includes("Feed") ||
      location.pathname.split("/").includes("Podcast")
    ) {
      //return require('../../assets/feed.png');
    } else {
     // return require('../../assets/teach.png');
    }
  };

  return (
    <Grid container sx={{ height: "100vh" }}>
      {!fullScreen && (
        <>
          <Grid item xs={2} sm={2} md={2} className="BgColor">
            <Box sx={{ height: "68vh" }}>
              {/* {userInfo !== undefined && userInfo !== null && 
                        <Typography variant="h4" gutterBottom color="" component="div">
                            Welcome, {userInfo.name.firstname+' '+userInfo.name.lastname} !
                        </Typography>
                    } */}
              {/* <Button variant="contained" color='secondary' onClick={home} sx={{ marginRight: 3}}>Home</Button>
                    <Button variant="contained" color='secondary' onClick={logout}>Logout</Button> */}
              <nav aria-label="main mailbox folders" className="">
                {userInfo &&
                  userInfo.rolesInfo &&
                  userInfo.rolesInfo.title.toLowerCase() == "trainer" && (
                    <List className="m-ml-xs">
                      <ListItem
                        disablePadding
                        sx={{
                          mb: 2,
                        }}
                        onClick={() => goTo("/Teach")}
                      >
                        <ListItemButton sx={{ justifyContent: "center" }}>
                          <ListItemIcon>
                            <img
                              src={require("../../assets/Vocablab_white.png")}
                              className={classes.logoImg}
                            ></img>
                          </ListItemIcon>
                        </ListItemButton>
                      </ListItem>
                      {userAbilities &&
                        userAbilities.indexOf("course") > -1 && (
                          <ListItem
                            id="Teach"
                            disablePadding
                            className={
                              location.pathname.split("/").includes("Teach")
                                ? "Menustyle"
                                : ""
                            }
                            onClick={() => goTo("/Teach")}
                          >
                            <ListItemButton>
                              {/* <ListItemIcon>
                                <img
                                  src={
                                    location.pathname
                                      .split("/")
                                      .includes("Teach")
                                      ? require("../../assets/teach_active.png")
                                      : require("../../assets/teach_inactive.png")
                                  }
                                  className={classes.image}
                                ></img>
                              </ListItemIcon> */}
                              <ListItemText
                                className={
                                  location.pathname.split("/").includes("Teach")
                                    ? "text"
                                    : "textunselect"
                                }
                              >
                                <Typography
                                  sx={{
                                    fontSize: "1.3vw",
                                    fontWeight: "600",
                                    textAlign: "center"
                                  }}
                                >
                                  Learning
                                </Typography>
                              </ListItemText>
                            </ListItemButton>
                          </ListItem>
                        )}
                      {userAbilities && userAbilities.indexOf("task") > -1 && (
                        <ListItem
                          id="Task"
                          disablePadding
                          className={
                            location.pathname.split("/").includes("Task")
                              ? "Menustyle pl-1-5 py-02"
                              : "py-02 pl-1-5"
                          }
                          onClick={() => goTo("/Task")}
                        >
                          <ListItemButton>
                            {/* <ListItemIcon>
                              <img
                                src={
                                  location.pathname.split("/").includes("Task")
                                    ? require("../../assets/task_active.png")
                                    : require("../../assets/task_inactive.png")
                                }
                                className={classes.image}
                              ></img>
                            </ListItemIcon> */}
                            <ListItemText
                              className={
                                location.pathname.split("/").includes("Task")
                                  ? "text"
                                  : "textunselect"
                              }
                            >
                              <Typography
                                sx={{
                                  fontSize: "1.3vw",
                                  fontWeight: "600",
                                    textAlign: "center"
                                }}
                              >
                                Questions
                              </Typography>
                            </ListItemText>
                          </ListItemButton>
                        </ListItem>
                      )}
                      {userAbilities &&
                        userAbilities.indexOf("assignTask") > -1 && (
                          <ListItem
                            id="Assign"
                            disablePadding
                            className={
                              location.pathname.split("/").includes("Assign")
                                ? "Menustyle pl-1-5 py-02"
                                : "py-02 pl-1-5"
                            }
                            onClick={() => goTo("/Assign")}
                          >
                            <ListItemButton>
                              {/* <ListItemIcon>
                                <img
                                  src={
                                    location.pathname
                                      .split("/")
                                      .includes("Assign")
                                      ? require("../../assets/assign_active.png")
                                      : require("../../assets/assign_inactive.png")
                                  }
                                  className={classes.image}
                                ></img>
                              </ListItemIcon> */}
                              <ListItemText
                                className={
                                  location.pathname
                                    .split("/")
                                    .includes("Assign")
                                    ? "text"
                                    : "textunselect"
                                }
                              >
                                <Typography
                                  sx={{
                                    fontSize: "1.3vw",
                                    fontWeight: "600",
                                    textAlign: "center"
                                  }}
                                >
                                  Homework
                                </Typography>
                              </ListItemText>
                            </ListItemButton>
                          </ListItem>
                        )}
                      {userAbilities &&
                        userAbilities.indexOf("evaluateAssignment") > -1 && (
                          <ListItem
                            id="Assess"
                            disablePadding
                            className={
                              location.pathname.split("/").includes("Assess")
                                ? "Menustyle pl-1-5 py-02"
                                : "py-02 pl-1-5"
                            }
                            onClick={() => goTo("/Assess")}
                          >
                            <ListItemButton>
                              {/* <ListItemIcon>
                                <img
                                  src={
                                    location.pathname
                                      .split("/")
                                      .includes("Assess")
                                      ? require("../../assets/assess_active.png")
                                      : require("../../assets/assess_inactive.png")
                                  }
                                  className={classes.image}
                                ></img>
                              </ListItemIcon> */}
                              <ListItemText
                                className={
                                  location.pathname
                                    .split("/")
                                    .includes("Assess")
                                    ? "text"
                                    : "textunselect"
                                }
                              >
                                <Typography
                                  sx={{
                                    fontSize: "1.3vw",
                                    fontWeight: "600",
                                    textAlign: "center"
                                  }}
                                >
                                  Evaluation
                                </Typography>
                              </ListItemText>
                            </ListItemButton>
                          </ListItem>
                        )}
                      {userAbilities &&
                        userAbilities.indexOf("report") > -1 && (
                          <ListItem
                            id="Report"
                            disablePadding
                            className={
                              location.pathname.split("/").includes("Report")
                                ? "Menustyle pl-1-5 py-02"
                                : "py-02 pl-1-5"
                            }
                            onClick={() => goTo("/Report")}
                          >
                            <ListItemButton>
                              {/* <ListItemIcon>
                                <img
                                  src={
                                    location.pathname
                                      .split("/")Learning
                                      .includes("Report")
                                      ? require("../../assets/report_active.png")
                                      : require("../../assets/report_inactive.png")
                                  }
                                  className={classes.image}
                                ></img>
                              </ListItemIcon> */}
                              <ListItemText
                                className={
                                  location.pathname
                                    .split("/")
                                    .includes("Report")
                                    ? "text"
                                    : "textunselect"
                                }
                              >
                                <Typography
                                  sx={{
                                    fontSize: "1.3vw",
                                    fontWeight: "600",
                                    textAlign: "center"
                                  }}
                                >
                                  Report
                                </Typography>
                              </ListItemText>
                            </ListItemButton>
                          </ListItem>
                        )}
                      {userAbilities &&
                        userAbilities.indexOf("library") > -1 && (
                          <ListItem
                            id="Library"
                            disablePadding
                            className={
                              location.pathname.split("/").includes("Library")
                                ? "Menustyle pl-1-5 py-02"
                                : "py-02 pl-1-5"
                            }
                            onClick={() => goTo("/Library")}
                          >
                            <ListItemButton>
                              {/* <ListItemIcon>
                                <img
                                  src={
                                    location.pathname
                                      .split("/")
                                      .includes("Library")
                                      ? require("../../assets/library_active.png")
                                      : require("../../assets/library_inactive.png")
                                  }
                                  className={classes.image}
                                ></img>
                              </ListItemIcon> */}
                              <ListItemText
                                className={
                                  location.pathname
                                    .split("/")
                                    .includes("Library")
                                    ? "text"
                                    : "textunselect"
                                }
                              >
                                <Typography
                                  sx={{
                                    fontSize: "1.3vw",
                                    fontWeight: "600",
                                    textAlign: "center"
                                  }}
                                >
                                  Digital Books
                                </Typography>
                              </ListItemText>
                            </ListItemButton>
                          </ListItem>
                        )}
                      <ListItem
                        disablePadding
                        className={
                          location.pathname.split("/").includes("Feed")
                            ? "Menustyle pl-1-5 py-02"
                            : "py-02 pl-1-5"
                        }
                        onClick={() => goTo("/Feed")}
                      >
                        <ListItemButton>
                          {/* <ListItemIcon>
                            <img
                              src={
                                location.pathname.split("/").includes("Feed")
                                  ? require('../../assets/feed_active.png')
                                  : require('../../assets/feed_inactive.png')
                              }
                              className={classes.image}
                            ></img>
                          </ListItemIcon> */}
                          <ListItemText
                            className={
                              location.pathname.split("/").includes("Feed")
                                ? "text"
                                : "textunselect"
                            }
                          >
                            <Typography
                              sx={{
                                fontSize: "1.3vw",
                                fontWeight: "600",
                                    textAlign: "center"
                              }}
                            >
                              Podcasts
                            </Typography>
                          </ListItemText>
                        </ListItemButton>
                      </ListItem>
                    </List>
                  )}
                {userInfo &&
                  userInfo.rolesInfo &&
                  userInfo.rolesInfo.title.toLowerCase() == "learner" && (
                    <List className="m-ml-xs">
                      <ListItem
                        disablePadding
                        sx={{ mb: 2 }}
                        onClick={() => goTo("/Assignment")}
                      >
                        <ListItemButton sx={{ justifyContent: "center" }}>
                          <ListItemIcon>
                            <img
                              src={require("../../assets/Vocablab_white.png")}
                              className={classes.logoImg}
                            ></img>
                          </ListItemIcon>
                        </ListItemButton>
                      </ListItem>

                      {userAbilities &&
                        userAbilities.indexOf("assignment") > -1 && (
                          <ListItem
                            disablePadding
                            className={
                              location.pathname
                                .split("/")
                                .includes("Assignment")
                                ? "Menustyle pl-1-5 py-02"
                                : "py-02 pl-1-5"
                            }
                            onClick={() => goTo("/Assignment")}
                          >
                            <ListItemButton>
                              {/* <ListItemIcon>
                                <img
                                  src={
                                    location.pathname
                                      .split("/")
                                      .includes("Assignment")
                                      ? require("../../assets/assignment_active.png")
                                      : require("../../assets/assignment_inactive.png")
                                  }
                                  className={classes.image}
                                ></img>
                              </ListItemIcon> */}
                              <ListItemText
                                className={
                                  location.pathname
                                    .split("/")
                                    .includes("Assignment")
                                    ? "text"
                                    : "textunselect"
                                }
                              >
                                <Typography
                                  sx={{
                                    fontSize: "1.3vw",
                                    fontWeight: "600",
                                    textAlign: "center"
                                  }}
                                >
                                  Assignment
                                </Typography>
                              </ListItemText>
                            </ListItemButton>
                          </ListItem>
                        )}
                      <ListItem
                        disablePadding
                        className={
                          location.pathname.split("/").includes("Rewards")
                            ? "Menustyle pl-1-5 py-02"
                            : "py-02 pl-1-5"
                        }
                        onClick={() => goTo("/Rewards")}
                      >
                        <ListItemButton>
                          {/* <ListItemIcon>
                            <img
                              src={
                                location.pathname.split("/").includes("Rewards")
                                  ? require("../../assets/rewards_active.png")
                                  : require("../../assets/rewards_inactive.png")
                              }
                              className={classes.image}
                            ></img>
                          </ListItemIcon> */}
                          <ListItemText
                            className={
                              location.pathname.split("/").includes("Rewards")
                                ? "text"
                                : "textunselect"
                            }
                          >
                            <Typography
                              sx={{
                                fontSize: "1.3vw",
                                fontWeight: "600",
                                    textAlign: "center"
                              }}
                            >
                              Rewards
                            </Typography>
                          </ListItemText>
                        </ListItemButton>
                      </ListItem>
                      {userAbilities &&
                        userAbilities.indexOf("report") > -1 && (
                          <ListItem
                            disablePadding
                            className={
                              location.pathname.split("/").includes("Report")
                                ? "Menustyle pl-1-5 py-02"
                                : "py-02 pl-1-5"
                            }
                            onClick={() => goTo("/Report")}
                          >
                            <ListItemButton>
                              {/* <ListItemIcon>
                                <img
                                  src={
                                    location.pathname
                                      .split("/")
                                      .includes("Report")
                                      ? require("../../assets/report_active.png")
                                      : require("../../assets/report_inactive.png")
                                  }
                                  className={classes.image}
                                ></img>
                              </ListItemIcon> */}
                              <ListItemText
                                className={
                                  location.pathname
                                    .split("/")
                                    .includes("Report")
                                    ? "text"
                                    : "textunselect"
                                }
                              >
                                <Typography
                                  sx={{
                                    fontSize: "1.3vw",
                                    fontWeight: "600",
                                    textAlign: "center"
                                  }}
                                >
                                  Report
                                </Typography>
                              </ListItemText>
                            </ListItemButton>
                          </ListItem>
                        )}
                      <ListItem
                        disablePadding
                        className={
                          location.pathname.split("/").includes("Feed")
                            ? "Menustyle pl-1-5 py-02"
                            : "py-02 pl-1-5"
                        }
                        onClick={() => goTo("/Feed")}
                      >
                        <ListItemButton>
                          {/* <ListItemIcon>
                            <img
                              src={
                                location.pathname.split("/").includes("Feed")
                                  ? require('../../assets/feed_active.png')
                                  : require('../../assets/feed_inactive.png')
                              }
                              className={classes.image}
                            ></img>
                          </ListItemIcon> */}
                          <ListItemText
                            className={
                              location.pathname.split("/").includes("Feed")
                                ? "text"
                                : "textunselect"
                            }
                          >
                            <Typography
                              sx={{
                                fontSize: "1.3vw",
                                fontWeight: "600",
                                    textAlign: "center"
                              }}
                            >
                              Feed
                            </Typography>
                          </ListItemText>
                        </ListItemButton>
                      </ListItem>
                    </List>
                  )}
                {userInfo &&
                  userInfo.rolesInfo &&
                  userInfo.rolesInfo.title.toLowerCase() == "incharge" && (
                    <List className="m-ml-xs">
                      <ListItem
                        disablePadding
                        sx={{ mb: 2 }}
                        onClick={() => goTo("/Dashboard")}
                      >
                        <ListItemButton sx={{ justifyContent: "center" }}>
                          <ListItemIcon>
                            <img
                              src={require("../../assets/Vocablab_white.png")}
                              className={classes.logoImg}
                            ></img>
                          </ListItemIcon>
                        </ListItemButton>
                      </ListItem>
                      <ListItem
                        disablePadding
                        className={
                          location.pathname.split("/").includes("Dashboard")
                            ? "Menustyle pl-1-5 py-02"
                            : "py-02 pl-1-5"
                        }
                        onClick={() => goTo("/Dashboard")}
                      >
                        <ListItemButton>
                          {/* <ListItemIcon>
                            <img
                              src={
                                location.pathname
                                  .split("/")
                                  .includes("Dashboard")
                                  ? require("../../assets/home_active.png")
                                  : require("../../assets/home_inactive.png")
                              }
                              className={classes.image}
                            ></img>
                          </ListItemIcon> */}
                          <ListItemText
                            className={
                              location.pathname.split("/").includes("Dashboard")
                                ? "text"
                                : "textunselect"
                            }
                          >
                            <Typography
                              sx={{
                                fontSize: "1.3vw",
                                fontWeight: "600",
                                    textAlign: "center"
                              }}
                            >
                              Home
                            </Typography>
                          </ListItemText>
                        </ListItemButton>
                      </ListItem>
                      {userAbilities &&
                        userAbilities.indexOf("manageUser") > -1 && (
                          <ListItem
                            disablePadding
                            className={
                              location.pathname.split("/").includes("Users")
                                ? "Menustyle pl-1-5 py-02"
                                : "py-02 pl-1-5"
                            }
                            onClick={() => goTo("/Users")}
                          >
                            <ListItemButton>
                              {/* <ListItemIcon>
                                <img
                                  src={
                                    location.pathname
                                      .split("/")
                                      .includes("Users")
                                      ? require("../../assets/user_active.png")
                                      : require("../../assets/user_inactive.png")
                                  }
                                  className={classes.image}
                                ></img>
                              </ListItemIcon> */}
                              <ListItemText
                                className={
                                  location.pathname.split("/").includes("Users")
                                    ? "text"
                                    : "textunselect"
                                }
                              >
                                <Typography
                                  sx={{
                                    fontSize: "1.3vw",
                                    fontWeight: "600",
                                    textAlign: "center"
                                  }}
                                >
                                  Users
                                </Typography>
                              </ListItemText>
                            </ListItemButton>
                          </ListItem>
                        )}
                      {userAbilities &&
                        userAbilities.indexOf("school") > -1 && (
                          <ListItem
                            disablePadding
                            className={
                              location.pathname.split("/").includes("School")
                                ? "Menustyle pl-1-5 py-02"
                                : "py-02 pl-1-5"
                            }
                            onClick={() => goTo("/School")}
                          >
                            <ListItemButton>
                              {/* <ListItemIcon>
                                <img
                                  src={
                                    location.pathname
                                      .split("/")
                                      .includes("School")
                                      ? require("../../assets/school_active.png")
                                      : require("../../assets/school_inactive.png")
                                  }
                                  className={classes.image}
                                ></img>
                              </ListItemIcon> */}
                              <ListItemText
                                className={
                                  location.pathname
                                    .split("/")
                                    .includes("School")
                                    ? "text"
                                    : "textunselect"
                                }
                              >
                                <Typography
                                  sx={{
                                    fontSize: "1.3vw",
                                    fontWeight: "600",
                                    textAlign: "center"
                                  }}
                                >
                                  School
                                </Typography>
                              </ListItemText>
                            </ListItemButton>
                          </ListItem>
                        )}
                      {userAbilities &&
                        userAbilities.indexOf("course") > -1 && (
                          <ListItem
                            disablePadding
                            className={
                              location.pathname.split("/").includes("Teach")
                                ? "Menustyle pl-1-5 py-02"
                                : "py-02 pl-1-5"
                            }
                            onClick={() => goTo("/Teach")}
                          >
                            <ListItemButton>
                              {/* <ListItemIcon>
                                <img
                                  src={
                                    location.pathname
                                      .split("/")
                                      .includes("Teach")
                                      ? require("../../assets/teach_active.png")
                                      : require("../../assets/teach_inactive.png")
                                  }
                                  className={classes.image}
                                ></img>
                              </ListItemIcon> */}
                              <ListItemText
                                className={
                                  location.pathname.split("/").includes("Teach")
                                    ? "text"
                                    : "textunselect"
                                }
                              >
                                <Typography
                                  sx={{
                                    fontSize: "1.3vw",
                                    fontWeight: "600",
                                    textAlign: "center"
                                  }}
                                >
                                  Courses
                                </Typography>
                              </ListItemText>
                            </ListItemButton>
                          </ListItem>
                        )}
                      {userAbilities &&
                        userAbilities.indexOf("report") > -1 && (
                          <ListItem
                            disablePadding
                            className={
                              location.pathname.split("/").includes("Report")
                                ? "Menustyle pl-1-5 py-02"
                                : "py-02 pl-1-5"
                            }
                            onClick={() => goTo("/Report")}
                          >
                            <ListItemButton>
                              {/* <ListItemIcon>
                                <img
                                  src={
                                    location.pathname
                                      .split("/")
                                      .includes("Report")
                                      ? require("../../assets/report_active.png")
                                      : require("../../assets/report_inactive.png")
                                  }
                                  className={classes.image}
                                ></img>
                              </ListItemIcon> */}
                              <ListItemText
                                className={
                                  location.pathname
                                    .split("/")
                                    .includes("Report")
                                    ? "text"
                                    : "textunselect"
                                }
                              >
                                <Typography
                                  sx={{
                                    fontSize: "1.3vw",
                                    fontWeight: "600",
                                    textAlign: "center"
                                  }}
                                >
                                  Report
                                </Typography>
                              </ListItemText>
                            </ListItemButton>
                          </ListItem>
                        )}
                      {userAbilities &&
                        userAbilities.indexOf("library") > -1 && (
                          <ListItem
                            disablePadding
                            className={
                              location.pathname.split("/").includes("Library")
                                ? "Menustyle pl-1-5 py-02"
                                : "py-02 pl-1-5"
                            }
                            onClick={() => goTo("/Library")}
                          >
                            <ListItemButton>
                              {/* <ListItemIcon>
                                <img
                                  src={
                                    location.pathname
                                      .split("/")
                                      .includes("Library")
                                      ? require("../../assets/library_active.png")
                                      : require("../../assets/library_inactive.png")
                                  }
                                  className={classes.image}
                                ></img>
                              </ListItemIcon> */}
                              <ListItemText
                                className={
                                  location.pathname
                                    .split("/")
                                    .includes("Library")
                                    ? "text"
                                    : "textunselect"
                                }
                              >
                                <Typography
                                  sx={{
                                    fontSize: "1.3vw",
                                    fontWeight: "600",
                                    textAlign: "center"
                                  }}
                                >
                                  Library
                                </Typography>
                              </ListItemText>
                            </ListItemButton>
                          </ListItem>
                        )}
                    </List>
                  )}
                {userInfo &&
                  userInfo.rolesInfo &&
                  userInfo.rolesInfo.title.toLowerCase() == "admin" && (
                    <List className="m-ml-xs">
                      <ListItem
                        disablePadding
                        sx={{ mb: 2 }}
                        onClick={() => goTo("/Dashboard")}
                      >
                        <ListItemButton sx={{ justifyContent: "center" }}>
                          <ListItemIcon>
                            <img
                              src={require("../../assets/Vocablab_white.png")}
                              className={classes.logoImg}
                            ></img>
                          </ListItemIcon>
                        </ListItemButton>
                      </ListItem>
                      <ListItem
                        disablePadding
                        className={
                          location.pathname.split("/").includes("Dashboard")
                            ? "Menustyle pl-1-5 py-02"
                            : "py-02 pl-1-5"
                        }
                        onClick={() => goTo("/Dashboard")}
                      >
                        <ListItemButton>
                          {/* <ListItemIcon>
                            <img
                              src={
                                location.pathname
                                  .split("/")
                                  .includes("Dashboard")
                                  ? require('../../assets/home_active.png')
                                  : require('../../assets/home_inactive.png')
                              }
                              className={classes.image}
                            ></img>
                          </ListItemIcon> */}
                          <ListItemText
                            className={
                              location.pathname.split("/").includes("Dashboard")
                                ? "text"
                                : "textunselect"
                            }
                          >
                            <Typography
                              sx={{
                                fontSize: "1.3vw",
                                fontWeight: "600",
                                    textAlign: "center"
                              }}
                            >
                              Home
                            </Typography>
                          </ListItemText>
                        </ListItemButton>
                      </ListItem>
                      <ListItem
                        disablePadding
                        className={
                          location.pathname.split("/").includes("Users")
                            ? "Menustyle pl-1-5 py-02"
                            : "py-02 pl-1-5"
                        }
                        onClick={() => goTo("/Users")}
                      >
                        <ListItemButton>
                          {/* <ListItemIcon>
                            <img
                              src={
                                location.pathname.split("/").includes("Users")
                                  ? require('../../assets/user_active.png')
                                  : require('../../assets/user_inactive.png')
                              }
                              className={classes.image}
                            ></img>
                          </ListItemIcon> */}
                          <ListItemText
                            className={
                              location.pathname.split("/").includes("Users")
                                ? "text"
                                : "textunselect"
                            }
                          >
                            <Typography
                              sx={{
                                fontSize: "1.3vw",
                                fontWeight: "600",
                                    textAlign: "center"
                              }}
                            >
                              Users
                            </Typography>
                          </ListItemText>
                        </ListItemButton>
                      </ListItem>
                      <ListItem
                        disablePadding
                        className={
                          location.pathname.split("/").includes("School")
                            ? "Menustyle pl-1-5 py-02"
                            : "py-02 pl-1-5"
                        }
                        onClick={() => goTo("/School")}
                      >
                        <ListItemButton>
                          {/* <ListItemIcon>
                            <img
                              src={
                                location.pathname.split("/").includes("School")
                                  ? require('../../assets/school_active.png')
                                  : require('../../assets/school_inactive.png')
                              }
                              className={classes.image}
                            ></img>
                          </ListItemIcon> */}
                          <ListItemText
                            className={
                              location.pathname.split("/").includes("School")
                                ? "text"
                                : "textunselect"
                            }
                          >
                            <Typography
                              sx={{
                                fontSize: "1.3vw",
                                fontWeight: "600",
                                    textAlign: "center"
                              }}
                            >
                              School
                            </Typography>
                          </ListItemText>
                        </ListItemButton>
                      </ListItem>
                      <ListItem
                        disablePadding
                        className={
                          location.pathname.split("/").includes("Teach")
                            ? "Menustyle pl-1-5 py-02"
                            : "py-02 pl-1-5"
                        }
                        onClick={() => goTo("/Teach")}
                      >
                        <ListItemButton>
                          {/* <ListItemIcon>
                            <img
                              src={
                                location.pathname.split("/").includes("Teach")
                                  ? require('../../assets/teach_active.png')
                                  : require('../../assets/teach_inactive.png')
                              }
                              className={classes.image}
                            ></img>
                          </ListItemIcon> */}
                          <ListItemText
                            className={
                              location.pathname.split("/").includes("Teach")
                                ? "text"
                                : "textunselect"
                            }
                          >
                            <Typography
                              sx={{
                                fontSize: "1.3vw",
                                fontWeight: "600",
                                    textAlign: "center"
                              }}
                            >
                              Courses
                            </Typography>
                          </ListItemText>
                        </ListItemButton>
                      </ListItem>
                      <ListItem
                        disablePadding
                        className={
                          location.pathname.split("/").includes("Report")
                            ? "Menustyle pl-1-5 py-02"
                            : "py-02 pl-1-5"
                        }
                        onClick={() => goTo("/Report")}
                      >
                        <ListItemButton>
                          {/* <ListItemIcon>
                            <img
                              src={
                                location.pathname.split("/").includes("Report")
                                  ? require('../../assets/report_active.png')
                                  : require('../../assets/report_inactive.png')
                              }
                              className={classes.image}
                            ></img>
                          </ListItemIcon> */}
                          <ListItemText
                            className={
                              location.pathname.split("/").includes("Report")
                                ? "text"
                                : "textunselect"
                            }
                          >
                            <Typography
                              sx={{
                                fontSize: "1.3vw",
                                fontWeight: "600",
                                    textAlign: "center"
                              }}
                            >
                              Report
                            </Typography>
                          </ListItemText>
                        </ListItemButton>
                      </ListItem>
                      <ListItem
                        disablePadding
                        className={
                          location.pathname.split("/").includes("Library")
                            ? "Menustyle pl-1-5 py-02"
                            : "py-02 pl-1-5"
                        }
                        onClick={() => goTo("/Library")}
                      >
                        <ListItemButton>
                          {/* <ListItemIcon>
                            <img
                              src={
                                location.pathname.split("/").includes("Library")
                                  ? require('../../assets/library_active.png')
                                  : require('../../assets/library_inactive.png')
                              }
                              className={classes.image}
                            ></img>
                          </ListItemIcon> */}
                          <ListItemText
                            className={
                              location.pathname.split("/").includes("Library")
                                ? "text"
                                : "textunselect"
                            }
                          >
                            <Typography
                              sx={{
                                fontSize: "1.3vw",
                                fontWeight: "600",
                                    textAlign: "center"
                              }}
                            >
                              Library
                            </Typography>
                          </ListItemText>
                        </ListItemButton>
                      </ListItem>
                    </List>
                  )}

                {userInfo &&
                  userInfo.rolesInfo &&
                  userInfo.rolesInfo.title.toLowerCase() == "staff" && (
                    <List className="m-ml-xs">
                      <ListItem
                        disablePadding
                        sx={{ mb: 2 }}
                        onClick={() => goTo("/Dashboard")}
                      >
                        <ListItemButton sx={{ justifyContent: "center" }}>
                          <ListItemIcon>
                            <img
                              src={require('../../assets/Vocablab_white.png')}
                              className={classes.logoImg}
                            ></img>
                          </ListItemIcon>
                        </ListItemButton>
                      </ListItem>
                      {siteConfig &&
                        siteConfig.customer?.addOnInfo?.isSelfLearning && (
                          <ListItem
                            disablePadding
                            className={
                              location.pathname.split("/").includes("Teach")
                                ? "Menustyle pl-1-5 py-02"
                                : "py-02 pl-1-5"
                            }
                            onClick={() => goTo("/Teach")}
                          >
                            <ListItemButton>
                              {/* <ListItemIcon>
                                <img
                                  src={
                                    location.pathname
                                      .split("/")
                                      .includes("Teach")
                                      ? require('../../assets/teach_active.png')
                                      : require('../../assets/teach_inactive.png')
                                  }
                                  className={classes.image}
                                ></img>
                              </ListItemIcon> */}
                              <ListItemText
                                className={
                                  location.pathname.split("/").includes("Teach")
                                    ? "text"
                                    : "textunselect"
                                }
                              >
                                <Typography
                                  sx={{
                                    fontSize: "1.3vw",
                                    fontWeight: "600",
                                    textAlign: "center"
                                  }}
                                >
                                  Courses
                                </Typography>
                              </ListItemText>
                            </ListItemButton>
                          </ListItem>
                        )}
                      <ListItem
                        disablePadding
                        className={
                          location.pathname.split("/").includes("Report")
                            ? "Menustyle pl-1-5 py-02"
                            : "py-02 pl-1-5"
                        }
                        onClick={() => goTo("/Report")}
                      >
                        <ListItemButton>
                          {/* <ListItemIcon>
                            <img
                              src={
                                location.pathname.split("/").includes("Report")
                                  ? require('../../assets/report_active.png')
                                  : require('../../assets/report_inactive.png')
                              }
                              className={classes.image}
                            ></img>
                          </ListItemIcon> */}
                          <ListItemText
                            className={
                              location.pathname.split("/").includes("Report")
                                ? "text"
                                : "textunselect"
                            }
                          >
                            <Typography
                              sx={{
                                fontSize: "1.3vw",
                                fontWeight: "600",
                                    textAlign: "center"
                              }}
                            >
                              Report
                            </Typography>
                          </ListItemText>
                        </ListItemButton>
                      </ListItem>
                    </List>
                  )}

                {userInfo &&
                  userInfo.rolesInfo &&
                  userInfo.rolesInfo.title.toLowerCase() == "broadcast" && (
                    <List className="m-ml-xs">
                      <ListItem
                        disablePadding
                        sx={{ mb: 2 }}
                        onClick={() => goTo("/Podcast")}
                      >
                        <ListItemButton sx={{ justifyContent: "center" }}>
                          <ListItemIcon>
                            <img
                              src={require('../../assets/Vocablab_white.png')}
                              className={classes.logoImg}
                            ></img>
                          </ListItemIcon>
                        </ListItemButton>
                      </ListItem>
                      <ListItem
                        disablePadding
                        className={
                          location.pathname.split("/").includes("Podcast")
                            ? "Menustyle pl-1-5 py-02"
                            : "py-02 pl-1-5"
                        }
                        onClick={() => goTo("/Podcast")}
                      >
                        <ListItemButton>
                          {/* <ListItemIcon>
                            <img
                              src={
                                location.pathname.split("/").includes("Podcast")
                                  ? require('../../assets/teach_active.png')
                                  : require('../../assets/teach_inactive.png')
                              }
                              className={classes.image}
                            ></img>
                          </ListItemIcon> */}
                          <ListItemText
                            className={
                              location.pathname.split("/").includes("Podcast")
                                ? "text"
                                : "textunselect"
                            }
                          >
                            <Typography
                              sx={{
                                fontSize: "1.3vw",
                                fontWeight: "600",
                                    textAlign: "center"
                              }}
                            >
                              Podcast
                            </Typography>
                          </ListItemText>
                        </ListItemButton>
                      </ListItem>
                    </List>
                  )}
              </nav>
            </Box>
            {/* <Box
              sx={{
                height: "32vh",
                marginLeft: "-5rem",
                "@media (min-width: 1636px)": { left: "-8rem" },
              }}
            >
              <img src={loadImage()} className={classes.carectorimage}></img>
            </Box> */}
          </Grid>
        </>
      )}
      <Grid
        item
        xs={fullScreen ? 12 : 10}
        sm={fullScreen ? 12 : 10}
        md={fullScreen ? 12 : 10}
        sx={{ px: 2, py: 2, background: "#ffadadff" }}
      >
        <Grid item container direction="row">
          <Grid item container>
            <Header
              libraryPermission={
                userAbilities && userAbilities.indexOf("library") > -1
              }
            />
          </Grid>
          {/* <Grid item xs={12} sx={{ borderTop: 1, borderTopColor: '#EFEFEF', marginLeft: 5, marginRight: 5, marginTop: 1 }}>
                        <span sx={{ color: 'red'}}>Class 6D | English | Module 4 | Session 4</span>
                    </Grid> */}
          <Grid item container>
            <Outlet />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};
const useStyles = makeStyles({
  image: {
    width: "2.4vw",
  },
  logoImg: {
    width: "8rem",
    "@media (min-width: 1636px)": {
      width: "10rem",
    },
  },
  carectorimage: {
    width: "19.5vw",
  },
});
export default MainStageLayout;
